import * as React from 'react';
import * as styles from './CarouselHeader.module.scss';
import clsx from 'clsx';

const LeftIcon = ({ className }: { className?: string }) => (
  <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.6673 14.6667H10.4407L17.894 7.21337L16.0007 5.33337L5.33398 16L16.0007 26.6667L17.8807 24.7867L10.4407 17.3334H26.6673V14.6667Z"
      fill="currentColor"
    />
  </svg>
);

export const CarouselHeader = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <div className={clsx(styles.carouselHeader, className)}>{children}</div>
);

const Title = ({ children, className }: { className?: string; children: React.ReactNode }) => (
  <p className={clsx(styles.carouselHeader__title, className)}>{children}</p>
);

const Navigation = ({
  className,
  onPrevClick,
  onNextClick,
}: {
  className?: string;
  onPrevClick(): void;
  onNextClick(): void;
}) => (
  <div className={clsx(styles.carouselHeader__navigation, className)}>
    <button aria-label="Previous item" onClick={onPrevClick}>
      <LeftIcon />
    </button>
    <button aria-label="Next item" onClick={onNextClick}>
      <LeftIcon className={styles.carouselHeader__rotate180} />
    </button>
  </div>
);

CarouselHeader.Title = Title;
CarouselHeader.Navigation = Navigation;
